import styled from '@emotion/styled';

import { customPalette } from '../../styles/theme';

export const Container = styled.div`
  padding: 24px;
  border-radius: 16px;
  max-width: 800px;
`;

export const Section = styled.div`
  margin-bottom: 32px;
`;

export const StyledHeader = styled.h1`
  color: ${customPalette.grey[800]};
  margin-bottom: 48px;
`;

export const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: ${customPalette.grey[800]};
  margin-bottom: 16px;
`;
